  import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de from 'vuetify/es5/locale/de';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    // themes: THEMES,
    themes: {
      light: {
        /**
         * needs the following sass property to be applied to v-app element
         * #v-app {
         *   background-color: var(--v-background-base);
         * }
         */
        background: '#fff',
        primary: colors.blue.darken2,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,

        //appBar: colors.cyan,
      },
      dark: {
        background: '#212121', //default '#212121'
      },
    },
  },

  lang: {
    locales: { de },
    current: 'de',
  },
});
